import { get } from '@/api';
import type { ICep } from '@/components/forms/interface/ICep';

export async function getCep(cep: string): Promise<ICep> {
  return (await get(`api/widget/cep/${cep}`)).body.data as ICep;
}
